module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-de.1f1906cbf136a5529039.svg";